import './hamburgerMenu.css';
import data from "../../utils/data.json";
import { useLanguage } from '../../context/LanguageContext';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

const HamburgerMenu = (props) => {

    /* --- props --- */
    const {
        setMobileMenu,
        isUserOnGalleria,
        setLavoraConNoiMobile        
    } = props;

    /* ------ Context API ------ */
    const { selectedLanguage, changeLanguage } = useLanguage();
    const langSwitch = selectedLanguage === "ita" ? "🇬🇧 EN" : "🇮🇹 ITA"

    /* ------ useState() ------ */
    const [routes, setRoutes] = useState([...data?.linksHambMenu?.[selectedLanguage], langSwitch]);
    const last = routes?.findLast(element => element);

    const handleOnTouch = (event, route) => {

        window.onscroll = function () {};

        switch (route) {
            case "lavora con noi":
            case "careers":
                const scrollTop  = window.scrollY;
                const scrollLeft = window.scrollX;

                window.onscroll = function() {
                    window.scrollTo(scrollLeft, scrollTop);
                };

                setLavoraConNoiMobile(true);
                break;
            case "chi siamo":
            case "about us":
                event.preventDefault();
                window.scrollTo({
                    top      : document.querySelector("#chisiamo")?.offsetTop,
                    behavior : 'smooth'
                });
                break;
            case "contatti":
            case "contacts":
                event.preventDefault();
                window.scrollTo({
                    top      : document.querySelector("#footer")?.offsetTop,
                    behavior : 'smooth'
                });
                break;
            case last:
                changeLanguage();
                break;
            default:
                throw new Error("Unknown route.");
        }
    };

    /* ------ useEffect() ------ */
    useEffect(() => {
        if (isUserOnGalleria) {

            const firstRouteToRemove = (selectedLanguage === "ita") ? "chi siamo" : "about us";
            const secondRouteToRemove = (selectedLanguage === "ita") ? "galleria" : "gallery";
            const updatedRoutes = data?.linksHambMenu?.[selectedLanguage]?.filter(route => {
                return route !== firstRouteToRemove && route !== secondRouteToRemove;
            })?.concat(langSwitch);

            setRoutes(updatedRoutes);
            
        } else {

            const routeToRemove = "home";
            const updatedRoutes = data?.linksHambMenu?.[selectedLanguage]?.filter(route => route !== routeToRemove);
            setRoutes([...updatedRoutes, langSwitch]);

        }
    }, [isUserOnGalleria, langSwitch, selectedLanguage]);

    return (
        <div 
            className="menu"
            onClick={() => {
                setMobileMenu(false);
                window.onscroll = function () {};
            }}
        >
            <ul>
                {routes?.map((route, index) => (
                    <li key={index} onClick={() => setMobileMenu(false)}>
                        {(route === "home" || route === "galleria" || route === "gallery") ? (
                            <Link to={(route === "galleria" || route === "gallery") ? "/galleria" : "/"}>
                                <p>{route}</p>
                            </Link>
                        ) : (
                            <button onClick={(e) => handleOnTouch(e, route)}>
                                {route}
                            </button>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default HamburgerMenu;